<h1 mat-dialog-title>{{ 'communications.add.title' | translate }}
  <span [ngClass]="{ 'd-none': !model.subject }"> - {{ model.subject }}</span>
</h1>
<mat-dialog-content>
  <app-card-spinner [visible]="dialogIsLoading" type="zero"></app-card-spinner>
  <div *ngIf="data.qrImage">
    <img src="{{ data.qrImage}}" width="150" height="150">
  </div>
  <div class="form-wrapper communication-form">
    <form [formGroup]="form">
      <!-- <div class="sender-info-wrapper">
        <div class="sender-label" mat-label>
          {{ 'communications.fields.sender' | translate }}
        </div>
        <span class="sender-email">
          {{ loggedUser.get("email") ? loggedUser.get("email") : '' }}
        </span>
      </div> -->
      <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
    </form>
  </div> <!-- /.form-wrapper -->
</mat-dialog-content> <!-- mat-dialog-content -->
<div class="row custom-dialog-footer">
  <div class="col-12 col-md-6 text-left">
    <a mat-button (click)="onClose()" mat-raised-button mat-default
      class="ml-3">{{ 'common.cta.close' | translate }}</a>
  </div> <!-- /.col -->
  <div class="col-12 col-md-6 text-right">
    <mat-spinner-button (btnClick)="onFormSubmit(model)" role="submit" [options]="formBtnOptions" class="btn-elevate">
    </mat-spinner-button>
  </div> <!-- /.col -->
</div> <!-- /.row -->